import baseUrl from '@pocapan/shared/utils/baseUrl';
import getToken from '@pocapan/shared/utils/getToken';

export default async function AddPost({
  title,
  content,
  artistId,
  dataUrls,
  photoCardId,
  locationId,
  eventId,
  postType,
  isAnonymous,
  repostSourceId,
  category
}) {
  return fetch(`${baseUrl()}/api/v1/posts`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${getToken()}`
    },
    body: JSON.stringify({
      post: {
        title: title,
        content: content,
        post_type: postType,
        data_urls: dataUrls,
        photo_card_id: photoCardId,
        location_id: locationId,
        event_id: eventId,
        anonymous: isAnonymous,
        artist_id: artistId,
        repost_source_id: repostSourceId,
        category: category
      }
    })
  });
}
